import { SanityContentPage } from 'src/components/layouts/Page/SanityContentPage'

const GiftingPage = () => {
  return <SanityContentPage slug='gifting' />
}

export default GiftingPage
